import { CreateProjectInterface, InviteInterface, ProjectInterface, UpdateProjectInterface } from "./interfaces";
import requestApi from "../../api/fetchApi";
import { CoworkerSchema } from "../../api/schemas/responses/users";


class ProjectsApi {

    /**
     * Получить список проектов.
     * */
    static async get_all(): Promise<ProjectInterface[]> {
        return requestApi.GET(`/api/projects`);
    }

    /**
     * Получить проект по id.
     * */
    static async get_by_id(id: string | number): Promise<ProjectInterface> {
        return requestApi.GET(`/api/projects/${id}`);
    }

    /**
     * Создать проект.
     * */
    static async create(project: CreateProjectInterface): Promise<ProjectInterface> {
        return await requestApi
            .POST(`/api/projects`, { body: project })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Обновить проект.
     * */
    static async update(project_id: number, project: UpdateProjectInterface): Promise<ProjectInterface> {
        return await requestApi
            .PATCH(`/api/projects/${project_id}`, { body: project })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Удалить проект.
     * */
    static async delete(project_id: number): Promise<ProjectInterface> {
        return await requestApi.DELETE(`/api/projects/${project_id}`);
    }

    /**
     * Получить исходящие приглашения для этого проекта.
     * */
    static async getInvites(project_id: number): Promise<InviteInterface[]> {
        return await requestApi.GET(`/api/projects-invites/${project_id}`);
    }

    /**
     * Принять приглашение в проект.
     * */
    static async createInvite(userId: number, projectId: number): Promise<InviteInterface[]> {
        return await requestApi.POST(
            `/api/projects-invites?project_id=${projectId}&user_id=${userId}`,
        );
    }

    /**
     * Отменить приглашение пользователя в проект.
     * */
    static async cancelInvite(inviteId: number): Promise<InviteInterface[]> {
        return await requestApi.DELETE(`/api/projects-invites/${inviteId}`);
    }

    /**
     * Получить пользователей проекта.
     * */
    static async getProjectCoworkers(projectId: number): Promise<CoworkerSchema[]> {
        return await requestApi.GET(`/api/projects/${projectId}/users`);
    }
}

export default ProjectsApi;
